import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { decorateComponent } from '../../helpers';

const mapStateToProps = ({ loading }) => ({
  domain: loading.get('domain'),
});
const homepage = (domain, path) => `https://www.getmyboat.${domain}${path}`;

export const BareIntlSEOMeta = ({
  domain,
  location: { pathname },
}) => {
  const language = 'en';

  return (
    <Helmet>
      <link rel="canonical" href={homepage(domain, pathname)} />
      <html lang={language} />
      <meta httpEquiv="content-language" content={language} />
      <meta name="google-site-verification" content="nv811terVIIzPPxnXEvsq9uF7AOSDyiXjoX4fp5swXY" />
    </Helmet>
  );
};

BareIntlSEOMeta.propTypes = {
  domain: PropTypes.string,
  location: PropTypes.object,
};

BareIntlSEOMeta.defaultProps = {
  domain: 'com',
};

const decorators = [
  withRouter,
  connect(mapStateToProps),
];

export default decorateComponent(BareIntlSEOMeta, decorators);
